export class BrandingConfig{
    id: number;
    primaryColor: string;
    secondaryColor: string;
    headerLogo: string;
    loginLogo: string;
    loginBackground: string;
    registerBackground: string;
    campaignId : number;

}
